import { useState } from "react";
import { toast } from "sonner";
import { RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { api } from "@/lib/api";

export const DemoResetSection = () => {
  const [busy, setBusy] = useState(false);
  const reset = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.resetDemo();
      toast.success("Demo reset with fresh data");
      setTimeout(() => window.location.reload(), 800);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not reset the demo");
      setBusy(false);
    }
  };
  return (
    <div className="rounded-lg border border-primary/30 bg-primary/5 p-4 space-y-2" data-testid="demo-reset-section">
      <p className="text-sm font-medium flex items-center gap-2"><RotateCcw className="w-4 h-4 text-primary" /> Demo company</p>
      <p className="text-xs text-muted-foreground">Emails from the demo only go to info@c-rossjobs.com. Reset puts every job, crew member, roster and timesheet back to fresh sample data dated around today.</p>
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <Button variant="outline" data-testid="demo-reset-btn" className="rounded-full">Reset demo</Button>
        </AlertDialogTrigger>
        <AlertDialogContent data-testid="demo-reset-confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Reset the demo company?</AlertDialogTitle>
            <AlertDialogDescription>Everything changed in the demo is removed and replaced with fresh sample data. The demo office and crew logins stay the same.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="demo-reset-cancel-btn" disabled={busy}>Cancel</AlertDialogCancel>
            <AlertDialogAction data-testid="demo-reset-confirm-btn" onClick={reset} disabled={busy}>{busy ? "Resetting…" : "Yes, reset"}</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
